import * as React from "react";
import styles from "./HorizontalCardImage.scss";

interface IProps {
    id?: string;
    src?: string;
}

const HorizontalCardImage: React.FunctionComponent<IProps> = (props: IProps) => (
    <div id={props.id} className={styles.cardImage} style={{ backgroundImage: `url(${props.src})` }} />
);

export default HorizontalCardImage;


// WEBPACK FOOTER //
// ./src/Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCardImage/HorizontalCardImage.tsx